<template>
    <section class="app-main">
        <div class="title">包邮设置</div>
        <div class="top-bar">
            <p>不设置是否包邮，则默认该地区不包邮。</p>
        </div>

        <div class="table-data">
            <el-table ref="table" row-key="id" :data="tableData" :loading="tableLoad" @select="handelSelectRow"  @select-all="selectAll" :tree-props="{children: 'children'}"  @selection-change="handleChange"  :indent="20" height="600"  style="width:1384px;">
                <el-table-column  type="selection" align="center" width="60" fixed="left"></el-table-column>
                <el-table-column prop="ename"   label="地区"  width="265"> </el-table-column>
                <el-table-column prop="free_shipping"   label="是否包邮"  width="180" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.free_shipping == 0">否</div>
                        <div v-else>是</div>
                    </template>
                </el-table-column>
                <el-table-column prop="money"   label="包邮金额"  width="200" align="center"> 
                    <template slot-scope="scope">
                        <div v-if="scope.row.free_shipping == 1">{{scope.row.money}}</div>
                        <div v-else>无</div>
                    </template>
                </el-table-column>
                <el-table-column prop="money"   label="预售包邮金额"  width="200" align="center"> 
                    <template slot-scope="scope">
                        <div v-if="scope.row.free_shipping == 1">{{scope.row.presale_money}}</div>
                        <div v-else>无</div>
                    </template>
                </el-table-column>
                <el-table-column prop="updated_at"   label="状态操作时间"  width="192" align="center"> 
                    <template slot-scope="scope">
                        <div v-if="scope.row.updated_at">{{scope.row.updated_at}}</div>
                        <div v-else>{{scope.row.created_at}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="245" align="center" >
                    <template slot-scope="scope">
                        <el-button type="info" plain size="mini"  @click="handleEdit(scope.row)">修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <tree-table :data="tableData" :columns="columns" border/> -->
        </div>
        <!-- 修改包邮设置 -->
        <el-dialog title="修改包邮设置"  :visible.sync="settingModal"  width="480px" center>
            <el-form ref="form" :model="setting" label-width="80px" style="padding:0 30px;">
                <el-form-item label="地区">
                    <p v-text="setting.area" :title="setting.area" class="area"></p>
                </el-form-item>
                <el-form-item label="是否包邮">
                    <el-radio v-model="setting.free_shipping" :label="1">是</el-radio>
                    <el-radio v-model="setting.free_shipping" :label="0">否</el-radio>
                </el-form-item>
                <el-form-item label="包邮金额" v-show="setting.free_shipping">
                    <el-input v-model="setting.money" placeholder="输入包邮金额"></el-input>
                </el-form-item>
                <el-form-item label="预售包邮" v-show="setting.free_shipping">
                    <el-input v-model="setting.presale_money" placeholder="输入预售包邮金额"></el-input>
                </el-form-item>
                <el-form-item label="注意事项">
                    <p style="line-height:20px;">如果修改的是一级城市，此操作将默认修改一级城市下面的所有二级城市和三级城市。修改二级城市同理。</p>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="settingModal = false">取 消</el-button>
                <el-button type="primary" @click="handeleSetting">确 定</el-button>
            </span>
        </el-dialog>

    </section>
</template>

<style lang="less" scoped>
section{
    .title {
        font-size: 18px;
        color: #141414;
        line-height:60px;
        letter-spacing: 0.4px;
        text-align: left;
    }
    .top-bar {
        display: flex;
        >p {
            line-height: 42px;
            letter-spacing: 0.3px;
            font-size: 14px;
            color: #141414;
            margin-right: 20px;
        }
    }
}
.area {
    height: 40px;
    line-height: 40px;
    color: #141414;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>




<script>
import { postageList,postageEdit } from '@/api/market.js'
export default {
    data() {
        return {
            tableData:[],
            tableLoad:false,
            settingModal:false,    // 修改弹窗
            setting:{
                area:'温哥华',
                free_shipping: 0,
                money:'',
                presale_money: ''
            },
            checkRows:[],        // 选中修改的行数据 id 集合
        }
    },
    methods: {
        getData(){
            // console.log(this.$store.state.userId);
            postageList({shops_id : 1}).then( (res) => {
                if(res.code == 20000){
                    this.tableData = res.list;
                }else{
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                console.log('request failed')
            })
        },
        selectAll() {
            this.$refs.table.data.map((items) => {
                 if (items.children) {
                    if (!items.isChecked) { //若遍历出来的行未选中
                        this.$refs.table.toggleRowSelection(items, true); //行变为选中状态
                        items.isChecked = true; //更新标志参数
                        items.children.map((item) => { //遍历子节点并改变状态与标志参数
                            this.$refs.table.toggleRowSelection(item, true);
                            item.isChecked = true;
                            item.children.map((it) => { //遍历子节点并改变状态与标志参数
                                this.$refs.table.toggleRowSelection(it, true);
                                it.isChecked = true;
                            });
                        });
                    } else { //选中状态同理
                        this.$refs.table.toggleRowSelection(items, false);
                        items.isChecked = false;
                        items.children.map((item) => {
                            this.$refs.table.toggleRowSelection(item, false);
                            item.isChecked = false;
                            item.children.map((it) => { //遍历子节点并改变状态与标志参数
                                this.$refs.table.toggleRowSelection(it, false);
                                it.isChecked = false;
                            });
                        });
                    }
                }
                else{
                    if (!items.isChecked) items.isChecked = true;
                    else items.isChecked = false;
                }
            }) 
        },
        handelSelectRow (selection, row) {
            console.log(row);
            if (row.children) { //只对有子节点的行响应
                if (!row.isChecked) {   //由行数据中的元素isChecked判断当前是否被选中
                    row.children.map((item) => { //遍历所有子节点
                        this.$refs.table.toggleRowSelection(item, true); //切换该子节点选中状态
                        /*
                        方法名                    说明                                      参数
                                            用于多选表格，切换某一行的选中状态，         row, selected
                        toggleRowSelection   如果使用了第二个参数，则是设置这一行
                                            选中与否（selected 为 true 则选中）
                        */
                        item.isChecked = true;
                        if (item.children && item.children.length>0) {
                            item.children.map((items) => {
                             this.$refs.table.toggleRowSelection(items, true);
                             items.isChecked = true;
                            })
                        }
                    });
                    row.isChecked = true; //当前行isChecked标志元素切换为false
                } else {
                    row.children.map((item) => {
                        this.$refs.table.toggleRowSelection(item, false);
                        item.isChecked = false;
                        if (item.children && item.children.length>0) {
                                item.children.map((items) => {
                                this.$refs.table.toggleRowSelection(items, false);
                                items.isChecked = false;
                            })
                        }
                    });
                    row.isChecked = false;
                }
                // console.log(this.multipleSelection, row);
            }else {
                row.isChecked = false;
            }
            
        },
        toggleRowSelection(rows,bol){
            // if (判断表格是否有数据) {
                for (let i = 0; i <rows.length ; i++) {
                    let row = rows[i];
                    this.$set(row,'isChecked',bol);
                    this.$refs.table.toggleRowSelection(row,bol);
                }
                console.log(rows)
            // }
        },
        // 监听选中事件
        handleChange(){
        },
        handleEdit(row){
            this.checkRows = [];
            this.checkRows.push(row.id)
            if (row.children && row.children.length>0){
                row.children.forEach(ele => {
                    if (ele.children && ele.children.length>0){
                        ele.children.forEach(item=>{
                            if (item.isChecked) {
                                this.checkRows.push(item.id); 
                            }     
                        })
                    }
                    if (ele.isChecked) {
                        this.checkRows.push(ele.id); 
                    }     
                })
            }
            this.setting.area = row.ename;
            this.setting.free_shipping = row.free_shipping;
            this.setting.money = row.money;
            this.setting.presale_money = row.presale_money;
            this.settingModal = true;
        },
        handeleSetting(){
            console.log(this.setting)
            let params = {  },id = this.checkRows.join(',');
            if(this.setting.free_shipping == 1){
                if(this.setting.money == 0 || this.setting.money == ""){
                    this.$message.error("请设置该地区的包邮费用")
                    return false;
                }else if(this.setting.presale_money == 0 || this.setting.presale_money == ""){
                    this.$message.error("请设置该地区的预售包邮费用")
                    return false;
                }else{
                    params.free_shipping = 1;
                    params.money     = this.setting.money;
                    params.presale_money =  this.setting.presale_money;
                }
            }else{
                params.free_shipping = 0;
            }

            postageEdit(id,params).then( (res) => {
                if(res.code == 20000){
                    this.getData();
                    this.$message({message:res.msg,type:'success'});
                    this.settingModal = false;
                }else{
                    this.$message.error(res.msg)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        handleEditRows(){

        }
    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
    
}
</script>
